// extracted by mini-css-extract-plugin
export var container = "FeatureBenefits-module--container--7IJfi";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var row = "FeatureBenefits-module--row--zMyJR";
export var sectionContainer = "FeatureBenefits-module--sectionContainer--S+lIC";
export var title = "FeatureBenefits-module--title--onLTC";